module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/faq-components/detail-faq/detail-faq.component.scss
// module id = ./src/app/faq-components/detail-faq/detail-faq.component.scss
// module chunks = main